const constants = {
    SITE_TITLE: process.env.REACT_APP_SITE_TITLE,
    SITE_HEADER: process.env.REACT_APP_SITE_HEADER,
    SITE_SUB_HEADER: process.env.REACT_APP_SITE_SUB_HEADER,
};

export default constants;